import { css } from '@emotion/css';

const container = css({
  '&.MuiBox-root': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    maxWidth: '400px',
    margin: '0 auto',
  },
});

const iconContainer = css({
  '&.MuiBox-root': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    position: 'relative',
    width: '60px',
    height: '60px',
    borderRadius: '50%',
  },
});

const awesomeIcon = css({
  '&.MuiSvgIcon-root': {
    fontSize: '20px',
    position: 'absolute',
    top: '0',
    right: '0',
  },
});

const titleText = css({
  '&.MuiTypography-root': {
    textAlign: 'center',
  },
});

const subtitleText = css({
  '&.MuiTypography-root': {
    textAlign: 'center',
  },
});

const AlertMessageStyles = {
  container,
  iconContainer,
  awesomeIcon,
  titleText,
  subtitleText,
};

export default AlertMessageStyles;
